import React from 'react';
import Header from '../../../../../../components/Stake/header';
import UniIcon from '../../../../../../assets/images/labs-uni-icon.svg';
import LabsUniClosedLogo from '../../../../../../assets/images/labs-uni-closed-logo.svg';
import StakingStub from '../../../../../../components/staking-stub';
import { LABS_UNI } from '../../../../../../constants/blockchain-constants';

const ClosedStub = () => (
  <>
    <Header icon={UniIcon} title='UNI LABS/ETH-Staking' />
    <StakingStub
      type={LABS_UNI}
      icon={LabsUniClosedLogo}
      text='The UNI LABS/ETH staking pool is closed.'
    />
  </>
);

export default ClosedStub;
